import { configure } from '@monterosa-sdk/core';
import {
  embed,
  getExperience,
  onMessage,
  requestMoreData
} from '@monterosa-sdk/launcher-kit';

import 'regenerator-runtime/runtime';
import createFormattedEmbed from "./create-formatted-embed";
/**
 * Initialises the component when passed an element
 *
 * @param {HTMLNode} rootElement The component dom node
 */
export default function(rootElement) {
  if (!rootElement || !rootElement.attributes['data-consent']) {
    return;
  }

  const init = async () => {
    const projectId = rootElement.dataset.projectId;
    const eventId = rootElement.dataset.eventId;
    const elementId = rootElement.dataset.elementId;
    const isDfl = rootElement.dataset.isDfl;

    configure({
      host: 'cdn.monterosa.cloud',
      projectId
    });

    const parameters = elementId ? { element: elementId } : {};

    let experience;
    let formattedEmbedUrl;

    if (isDfl === 'true' || isDfl === true) {

      try {
        formattedEmbedUrl = await createFormattedEmbed(rootElement);
        parameters.tenant = 'SKY';
        experience = getExperience({ experienceUrl: formattedEmbedUrl, parameters, autoresizesHeight: true });
      } catch (e) {
        console.error(e);
        return;
      }
    } else {
      experience = getExperience({ projectId, eventId, parameters, autoresizesHeight: true });
    }

    const innerElement = rootElement.querySelector('.ui-vendor-monterosa__inner');
    let targetDomElementId = innerElement.id;

    if (!targetDomElementId) {
      targetDomElementId = `monterosa-experience-${projectId}-${eventId}`;
      innerElement.id = targetDomElementId;
    }

    const topics = ['fankitAnalytics', 'tracking'];
    onMessage(experience, (message) => {
      if (topics.includes(message.action)) {
        const payload = message.payload;
        const trackingData = {
          eventCategory: payload.event_category,
          userActionName: payload.user_action_name,
          eventLabel: payload.event_label,
          elementId: payload.element_id
        };
        if (window.sdc && window.sdc.pubSub) {
          window.sdc.pubSub.publish('widget-interaction', trackingData);
        }
      }
    });

    await embed(experience, targetDomElementId);

    window.addEventListener('scroll', () => {
      const viewportHeight = Math.max(
        window.innerHeight,
        window.visualViewport ? window.visualViewport.height : 0
      );

      const scrollPositionBelowThreshold = Math.ceil(viewportHeight + window.scrollY) >= document.body.offsetHeight;
      if (scrollPositionBelowThreshold) {
        requestMoreData(experience);
      }
    });
  };

  if (!window.sdc || !window.sdc.checkConsent) {
    init();
    rootElement.dataset.consent = 'true';
    return;
  }

  window.sdc.checkConsent(rootElement, init);
}
